const blue = {
  5: '#f6f9ff',
  10: '#8ea8fd',
  20: '#8ea8fd',
  30: '#8ea8fd',
  50: '#3564fd',
  60: '#0037cf',
  70: '#0030b7',
  80: '#002896',
  90: '##001a61'
};

const red = {
  5: '#fff4f4',
  10: '#ffe2e2',
  20: '#ffc1bf',
  30: '#ffb3b2',
  40: '#ff8382',
  50: '#f66b69',
  60: '#e74442',
  70: '#d34040',
  80: '#a20e0e',
  90: '#790000'
};

const yellow = {
  5: '#fff3e6',
  10: '#ffd9af',
  20: '#ffaf55',
  30: '#f59831',
  40: '#e88615',
  50: '#d6770a',
  60: '#c16c0a',
  70: '#ad6008'
};

const green = {
  5: '#e9fbf4',
  10: '#c4ebdb',
  20: '#93dabe',
  30: '#50c093',
  40: '#119d71',
  50: '#008057',
  60: '#006746',
  70: '#00593d',
  80: '#00432b',
  90: '#003323'
};

const grey = {
  5: '#fafafa',
  10: '#f2f2f2',
  30: '#e3e3e3',
  50: '#bdbdbd',
  60: '#9e9e9e',
  70: '#737373',
  80: '#565656',
  90: '#3a3a3a'
};

const colors = {
  current: 'current',
  transparent: 'transparent',
  active: {
    base: blue['50'],
    hover: blue['70'],
    disabled: blue['30']
  },
  success: {
    base: green['30'],
    hover: green['70'],
    disabled: green['30']
  },
  warning: {
    base: yellow['30'],
    hover: yellow['50'],
    disabled: yellow['10']
  },
  error: {
    base: red['60'],
    hover: red['70'],
    disabled: red['30']
  },
  blue,
  red,
  yellow,
  green,
  grey
};

export default colors;
